import { ROUTE_PATH, TEMPLATE_OPTIONS } from "common/constants/sm-constants";
import { FormMetaModel, SmDatepickerModel, SmRadioModel, SmMetaSelectModel, SmCheckboxModel, SmMetaTextAreaModel, SmBtnMetaModel } from "common/models/utility-models/meta-model";

export class NotificationMetaModel extends FormMetaModel {
    constructor() {
        super('Add Notification', ROUTE_PATH.notificationgrid, ROUTE_PATH.notificationAdd, 4);
    }

    override initProperties(): any {
        const formInfo = super.initProperties();
        // const announcement_datetime = new SmDatepickerModel(
        //     'announcement_datetime',
        //     'announcement_datetime',
        //     'datetimepicker',
        //     false,
        //     'col-12 col-md-4 mb-2',
        //     1,
        //     1,
        //     'Start Date and Time',
        //     'text',
        //     '',
        //     true,
        //     true,
        //     true,
        //     false,
        //     false,
        //     'd/M/yyyy hh:mm',
        //     new Date('1970-10-19'),
        //     new Date('2040-01-01'),
        //     [],
        //     false
        // );

        const announcement_datetime = new SmDatepickerModel(
            'announcement_datetime',
            'announcement_datetime',
            'datetimepicker',
            true,
            'col-12 col-md-4 mb-2',
            1,
            1,
            'Start Date and Time',
            'text',
            '',
            false,
            true,
            true,
            false,
            false,
            'd/M/yyyy hh:mm',
            new Date('1970-10-19'),
            new Date('2040-01-01'),
            [],
            false
          );


        const announcement_type = new SmRadioModel(
            'announcement_type',
            'announcement_type',
            'radio',
            true,
            'col-xs-12 col-sm-12 col-md-4 col-lg-4 main-gender',
            1,
            2,
            'Choose Template',
            'checkbox',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            false,
            { evalKey: '', evalParam: [] },
            '',
            2,


            [
                {
                    key: 'email',
                    value: ['off'],
                    label: 'Email',
                    decisiveKey: 'val',
                    prop: { key: 'required', value: true },
                },
                {
                    key: 'custom',
                    value: ['off'],
                    label: 'Custom',
                    decisiveKey: 'val',
                    prop: { key: 'required', value: true },
                },
            ]
        );

        const template_id = new SmMetaSelectModel(
            'template_id',
            'template_id',
            'ng-select',
            false,
            'col-xs-12 col-md-4 col-lg-4 col-sm-12',
            1,
            3,
            'Select Template',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            TEMPLATE_OPTIONS,
            'name',
            'id',
            false,
            false,
            false

        );

        // const send_by = new SmCheckboxModel(
        //     'send_by',
        //     'send_by',
        //     'checkbox',
        //     false,
        //     'col-12',
        //     1,
        //     4,
        //     'Send by',
        //     'checkbox',
        //     '',
        //     false,
        //     true,
        //     true,
        //     false,
        //     0,
        //     0,
        //     false,
        //     false
        // );


        const send_to = new SmCheckboxModel(
            'send_to',
            'send_to',
            'checkbox',
            false,
            'col-12',
            1,
            4,
            'All students',
            'checkbox',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            false
        );

        const content = new SmMetaTextAreaModel(
            'content',
            'content',
            'textarea',
            false,
            'col-12',
            1,
            4,
            'Content',
            'textarea',
            '',
            false,
            true,
            true,
            false,
            500,
            1,
            false,
            false,
        );



        const branch_id = new SmMetaSelectModel(
            'branch_id',
            'branch_id',
            'ng-select',
            false,
            'col-12 col-md-2',
            1,
            6,
            'Branch',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            TEMPLATE_OPTIONS,
            'department_name',
            'id',
            true,
        );
        const batch_id = new SmMetaSelectModel(
            'batch_id',
            'batch_id',
            'select',
            true,   //  for All Student Validation this is being made false
            'col-12 col-md-2',
            1,
            5,
            'Batch',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            TEMPLATE_OPTIONS,
            'batch_number',
            'id',
            
        );
        const group_id = new SmMetaSelectModel(
            'group_id',
            'group_id',
            'select',
            false,
            'col-12 col-md-3',
            1,
            7,
            'Group',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            [],
            'group_name',
            'id',
            true,
          );

         //   const region = new SmRadioModel(
        //     'announcement_type',
        //     'announcement_type',
        //     'radio',
        //     true,
        //     'col-xs-12 col-sm-12 col-md-4 col-lg-4 main-gender',
        //     1,
        //     2,
        //     'Choose Template',
        //     'checkbox',
        //     '',
        //     false,
        //     true,
        //     true,
        //     false,
        //     0,
        //     0,
        //     false,
        //     false,
        //     { evalKey: '', evalParam: [] },
        //     '',
        //     2,


        //     [
        //         {
        //             key: 'east',
        //             value: ['off'],
        //             label: 'east',
        //             decisiveKey: 'val',
        //             prop: { key: 'required', value: true },
        //         },
        //         {
        //             key: 'west',
        //             value: ['off'],
        //             label: 'west',
        //             decisiveKey: 'val',
        //             prop: { key: 'required', value: true },
        //         },
        //         {
        //             key: 'north',
        //             value: ['off'],
        //             label: 'north',
        //             decisiveKey: 'val',
        //             prop: { key: 'required', value: true },
        //         },
        //          {
        //             key: 'north',
        //             value: ['off'],
        //             label: 'north',
        //             decisiveKey: 'val',
        //             prop: { key: 'required', value: true },
        //         },
        //     ]
        // );

        const east = new SmCheckboxModel(
            'east',
            'east',
            'checkbox',
            false,
            'col-12',
            1,
            4,
            'East',
            'checkbox',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            false
          );
          const west = new SmCheckboxModel(
            'west',
            'west',
            'checkbox',
            false,
            'col-12',
            1,
            4,
            'West',
            'checkbox',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            false
          ); 
          const north = new SmCheckboxModel(
            'north',
            'north',
            'checkbox',
            false,
            'col-12',
            1,
            4,
            'North',
            'checkbox',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            false
          );
          const south = new SmCheckboxModel(
            'south',
            'south',
            'checkbox',
            false,
            'col-12',
            1,
            4,
            'South',
            'checkbox',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            false
          );


        const student_ids= new SmMetaSelectModel(
            'student_ids',
            'student_ids',
            'ng-select',
            true,   // for All Student Validation this is being made false
            'col-12',
            1,
            12,
            'Add Student',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            [],
            'name',
            'id',
            true

        );

        const totalStudentCount= new SmMetaSelectModel(
            'totalStudentCount',
            'totalStudentCount',
            'ng-select',
            false,
            'col-12',
            1,
            12,
            'Add Student',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            [],
            'name',
            'id',
            true
        );

        

    //    const initialStudentCount: number = 0;
    //    const removedStudentCount: number = 0;
        // const buttons = {
        //     submit: new SmBtnMetaModel('Submit', '', true, false, true, true),
        //     isFormControl: false
        // };
        const buttons = {
            submit: new SmBtnMetaModel('Submit', '', true, false, true, true),
            isFormControl: false,
        };
        const isMandatory= [
            batch_id,
            student_ids,
          ]

        return {
            formInfo,
            buttons,
            template_id,
            announcement_type,
            content,
            branch_id,
            batch_id,
            group_id,
            student_ids,
            totalStudentCount,
            // student_id,
            send_to,
            east, west, north, south,          
            announcement_datetime,
            isMandatory
        };
    }
}